const features = [
  {
    icon: 'ri-4k-line',
    title: '全高清画质',
    desc: '支持1080P与4K超清播放，画面细腻色彩真实，给您影院级视觉享受',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速不缓冲',
    desc: '全球CDN加速节点覆盖，即点即播无需等待，告别卡顿与缓冲烦恼',
  },
  {
    icon: 'ri-database-2-line',
    title: '海量片库',
    desc: '收录超过十万部影视作品，涵盖电影、剧集、综艺、动漫、纪录片全类型',
  },
  {
    icon: 'ri-calendar-check-line',
    title: '每日同步更新',
    desc: '院线新片、热播剧集第一时间上线，追剧日历自动提醒，永不错过精彩',
  },
  {
    icon: 'ri-device-line',
    title: '多端无缝切换',
    desc: '电脑、平板、手机全端适配，观影进度云端同步，随时随地继续观看',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            为什么选择
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            丫丫影院的核心优势
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            五年深耕影视领域，为数百万用户提供稳定流畅的高清观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {features.map((item) => (
            <div
              key={item.title}
              className="group bg-white rounded-2xl p-6 md:p-7 hover:bg-primary-50/50 transition-colors duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${item.icon} text-primary-600 text-xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}